var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Container, Tabs, Tab, Button, CircularProgress, Typography, Paper } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { RequerimentosApi } from '../../../apis/requerimento-api';
import { BoxContainerLayout } from '../../../components/BoxContainerLayout';
import { ProcessoHeader } from './components/ProcessoHeader';
import { AbaRequerente } from './tabs/AbaRequerente';
import { AbaBusca } from './tabs/AbaBusca';
import { AbaChecklist } from './tabs/AbaChecklist';
import { Routes } from '../../../routes/constants';
import { TipoProcessoEnum } from '../../../model/enums/TipoProcessoEnum';
var RequerimentoVisualizacao = function () {
    var _a, _b;
    var id = useParams().id;
    var navigate = useNavigate();
    var _c = useState(null), requerimento = _c[0], setRequerimento = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(undefined), error = _e[0], setError = _e[1];
    var _f = useState(0), tabIndex = _f[0], setTabIndex = _f[1];
    var getTabImovelLabel = function () {
        var _a;
        var tipoReq = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _a === void 0 ? void 0 : _a.referenciaServico;
        if (!tipoReq)
            return 'Dados do Imóvel';
        if (tipoReq === TipoProcessoEnum.BUSCA_PESQUISA) {
            return 'Dados da busca';
        }
        var processTypes = [
            TipoProcessoEnum.CERTIDAO_ADMINISTRATIVA,
            TipoProcessoEnum.SOLICITAR_CARGA_COPIA_DIGITALIZADA,
            TipoProcessoEnum.MAPA_MEMORIAL
        ];
        if (processTypes.includes(tipoReq)) {
            return 'Dados do Processo';
        }
        return 'Dados do Imóvel';
    };
    useEffect(function () {
        if (id) {
            console.log('RequerimentoVisualizacao - ID recebido:', id);
            handleLoadRequerimento(Number(id));
        }
    }, [id]);
    var handleLoadRequerimento = function (reqId) {
        setLoading(true);
        RequerimentosApi.buscarPorId(reqId)
            .then(function (response) {
            console.log('Requerimento carregado:', response);
            setRequerimento(response);
            setLoading(false);
        })
            .catch(function (err) {
            console.error('Erro ao carregar requerimento:', err);
            setError(err);
            setLoading(false);
        });
    };
    var handleTabChange = function (event, newValue) {
        setTabIndex(newValue);
    };
    var handleVoltar = function () {
        navigate(Routes.REQUERIMENTO_LISTAR.path);
    };
    if (loading) {
        return (_jsx(BoxContainerLayout, { children: _jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' } }, { children: _jsx(CircularProgress, {}) })) }));
    }
    if (error) {
        return (_jsx(BoxContainerLayout, { children: _jsxs(Box, __assign({ sx: { p: 4, textAlign: 'center' } }, { children: [_jsx(Typography, __assign({ variant: "h6", color: "error" }, { children: "Erro ao carregar requerimento." })), _jsx(Typography, __assign({ variant: "body2", color: "textSecondary", sx: { mt: 2 } }, { children: ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || (error === null || error === void 0 ? void 0 : error.message) || 'Erro desconhecido' })), _jsx(Button, __assign({ onClick: handleVoltar, startIcon: _jsx(ArrowBack, {}), sx: { mt: 2 } }, { children: "Voltar" }))] })) }));
    }
    if (!requerimento) {
        return (_jsx(BoxContainerLayout, { children: _jsxs(Box, __assign({ sx: { p: 4, textAlign: 'center' } }, { children: [_jsx(Typography, __assign({ variant: "h6", color: "error" }, { children: "Requerimento n\u00E3o encontrado." })), _jsx(Button, __assign({ onClick: handleVoltar, startIcon: _jsx(ArrowBack, {}), sx: { mt: 2 } }, { children: "Voltar" }))] })) }));
    }
    return (_jsx(BoxContainerLayout, { children: _jsxs(Container, __assign({ maxWidth: "lg", sx: { py: 4 } }, { children: [_jsx(ProcessoHeader, { requerimento: requerimento }), _jsx(Box, __assign({ sx: { width: '100%', mt: 4 } }, { children: _jsxs(Paper, __assign({ elevation: 0, sx: { border: '1px solid #E0E0E0', borderRadius: 2 } }, { children: [_jsxs(Tabs, __assign({ value: tabIndex, onChange: handleTabChange, indicatorColor: "primary", textColor: "primary", variant: "fullWidth", sx: {
                                    borderBottom: 1,
                                    borderColor: 'divider',
                                    '& .MuiTab-root': { fontWeight: 700, fontSize: '0.9rem' }
                                } }, { children: [_jsx(Tab, { label: "Dados do Requerente" }), _jsx(Tab, { label: getTabImovelLabel() }), _jsx(Tab, { label: "Checklist" })] })), _jsxs(Box, __assign({ sx: { py: 3, px: 3 } }, { children: [_jsx("div", __assign({ role: "tabpanel", hidden: tabIndex !== 0 }, { children: tabIndex === 0 && _jsx(AbaRequerente, { requerimento: requerimento }) })), _jsx("div", __assign({ role: "tabpanel", hidden: tabIndex !== 1 }, { children: tabIndex === 1 && _jsx(AbaBusca, { requerimento: requerimento }) })), _jsx("div", __assign({ role: "tabpanel", hidden: tabIndex !== 2 }, { children: tabIndex === 2 && _jsx(AbaChecklist, { requerimento: requerimento }) }))] }))] })) })), _jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', mt: 4, mb: 4 } }, { children: _jsx(Button, __assign({ variant: "outlined", color: "primary", startIcon: _jsx(ArrowBack, {}), onClick: handleVoltar, sx: {
                            fontWeight: 700,
                            borderRadius: 2,
                            px: 4,
                            py: 1,
                            borderColor: '#1976d2',
                            color: '#1976d2',
                            '&:hover': {
                                borderColor: '#1565c0',
                                backgroundColor: 'rgba(25, 118, 210, 0.04)'
                            }
                        } }, { children: "VOLTAR" })) }))] })) }));
};
export default RequerimentoVisualizacao;
